<template>
  <portal to="notification-outlet">
    <mdb-modal
      size="xl"
      :show="showModalAdd"
      @close="$emit('input', 'showModalAdd', false)"
    >
      <mdb-modal-header>
        <mdb-modal-title>Criar Nova Coleção</mdb-modal-title>
      </mdb-modal-header>
      <mdb-modal-body>
        <form @submit.prevent="handleSubmit">
          <div class="d-flex">
            <div
              class="d-flex flex-column justify-content-between flex-grow-1 w-100 grey-text p-3 m-0"
            >
              <div class="w-100 input-wrapper">
                <label for="name" class="mt-3 grey-text">Nome da Coleção</label>
                <input
                  v-model="name"
                  type="text"
                  id="name"
                  class="form-control"
                  required
                />
              </div>
              <div class="w-100 input-wrapper">
                <div class="row-label">
                  <label>Número do Whatsapp</label>
                  <label>Template</label>
                </div>
                <div
                  v-for="(element, index) in collection"
                  :key="index"
                  class="d-flex w-100"
                  style="column-gap: 3em"
                >
                  <v-select
                    :options="numbers"
                    class="flex-fill w-100"
                    v-model="element.selectedNumber"
                    @input="() => getTemplates(element.selectedNumber)"
                    :rules="[(v) => !!v || 'Número é obrigatório']"
                    required
                  >
                    <template #search="{ attributes, events }">
                      <input
                        class="vs__search"
                        :required="!element.selectedNumber"
                        v-bind="attributes"
                        v-on="events"
                      />
                    </template>
                  </v-select>
                  <v-select
                    :options="
                      element.selectedNumber &&
                      templatesByIdentifier[element.selectedNumber.value]
                        ? templatesByIdentifier[
                            element.selectedNumber.value
                          ].reduce((acc, el) => {
                            if (!acc.includes(el.name)) {
                              acc.push(el.name);
                            }
                            return acc;
                          }, [])
                        : []
                    "
                    class="flex-fill w-100"
                    :disabled="loadingTemplate"
                    v-model="element.selectedName"
                    @input="() => initPreview()"
                    required
                  >
                    <template #search="{ attributes, events }">
                      <input
                        class="vs__search"
                        :required="!element.selectedName"
                        v-bind="attributes"
                        v-on="events"
                      />
                    </template>
                  </v-select>
                </div>
                <mdb-btn
                  color="primary"
                  class="w-100 m-0 mt-0 mt-2 p-2"
                  style="font-size: 1rem"
                  @click="addGroup"
                  :disabled="disabledAddGroup"
                  >+</mdb-btn
                >
              </div>

              <div class="d-flex mt-4 gap-3 groupbuttons">
                <mdb-btn
                  class="flex-fill m-0 p-4"
                  color="danger"
                  @click.native="$emit('input', 'showModalAdd', false)"
                  >Cancelar</mdb-btn
                >
                <mdb-btn class="flex-fill m-0" type="submit" color="primary"
                  >Salvar</mdb-btn
                >
              </div>
            </div>

            <preview-template
              :selectedTemplateButtons="selectedTemplateButtons"
              :collection="collection"
              :selectedTemplateBody="selectedTemplateBody"
              :loadingPreview="loadingPreview"
            />
          </div>
        </form>
      </mdb-modal-body>
    </mdb-modal>
  </portal>
</template>

<script>
import {
  mdbModal,
  mdbModalHeader,
  mdbModalTitle,
  mdbModalBody,
  mdbBtn,
} from "mdbvue";

import { createTemplateCollection } from "../../services/TemplateCollection";
import { listTemplates, listTemplateDetails } from "../../services/Auth";
import PreviewTemplate from "../PreviewTemplate.vue";

export default {
  name: "ModalCreateCollection",
  props: ["showModalAdd", "credentials", "numbers"],
  components: {
    mdbModal,
    mdbModalHeader,
    mdbModalTitle,
    mdbModalBody,
    mdbBtn,
    PreviewTemplate,
  },
  data() {
    return {
      selectedTemplateBody: "",
      selectedTemplateButtons: [],
      selectedTemplateIdentifier: "",
      loadingTemplate: false,
      templatesData: [],
      loadingPreview: false,
      selectedName: "",
      selectedNumber: "",
      collection: [{}],
      indexCollection: 0,
      templatesByIdentifier: {},
      name: "",
    };
  },
  computed: {
    templates() {
      // remove and clean array to be unique
      return (this.templatesData || []).reduce((acc, el) => {
        if (!acc.includes(el.name)) {
          acc.push(el.name);
        }
        return acc;
      }, []);
    },
    disabledAddGroup() {
      const lastCollection = this.collection[this.collection.length - 1];
      return !lastCollection.selectedName || !lastCollection.selectedNumber;
    },
  },
  methods: {
    addGroup() {
      this.collection = [...this.collection, {}];
      // this.collection.push({});
    },

    getTemplates(selectedNumber) {
      if (!selectedNumber || !selectedNumber.value) {
        return [];
      }
      // if (!this.templatesByIdentifier[selectedNumber.value])
      this.loadingTemplate = true;
      this.loadingPreview = true;
      document.body.style.cursor = "progress";

      listTemplates(selectedNumber.value)
        .then((data) => {
          if (data.length) {
            this.$set(this.templatesByIdentifier, selectedNumber.value, data);
            // templatesByIdentifier[selectedNumber.value] = data;
            // element.selectedName = data[0].name;
            return (
              this.templatesByIdentifier[selectedNumber.value] || []
            ).reduce((acc, el) => {
              if (!acc.includes(el.name)) {
                acc.push(el.name);
              }
              return acc;
            }, []);
          }
        })
        .catch(() => {
          this.$toast.open({
            position: "top",
            message:
              "Ops, aconteceu um erro ao buscar os templates para o número selecionado! Tente novamente com outro número!",
            type: "error",
          });
        })
        .finally(() => {
          document.body.style.cursor = "auto";
          this.loadingTemplate = false;
        });
    },

    initPreview() {
      const lastCollection = this.collection[this.collection.length - 1];
      this.loadingPreview = true;
      console.log(
        this.templatesByIdentifier[lastCollection.selectedNumber.value].find(
          (el) => el.name == lastCollection.selectedName
        )._id
      );
      listTemplateDetails({
        identifier: lastCollection.selectedNumber.value,
        template_id: this.templatesByIdentifier[
          lastCollection.selectedNumber.value
        ].find((el) => el.name == lastCollection.selectedName)._id,
      })
        .then((data) => {
          if (data.length) {
            this.selectedTemplateBody = data[0].sample_text;
            this.selectedTemplateButtons = data[0].sample_buttons;
          }
        })
        .catch(() => {
          this.$toast.open({
            position: "top",
            message:
              "Ops, aconteceu um erro ao buscar a visualização do template escolhido para o número selecionado! Tente novamente com outro número!",
            type: "error",
          });
        })
        .finally(() => {
          document.body.style.cursor = "auto";
          this.loadingPreview = false;
        });
    },
    handleSubmit() {
      console.warn(this.showModalAdd);
      let identifiers = this.collection.reduce((acc, element) => {
        if (!acc.includes(element.selectedNumber.value)) {
          acc.push(element.selectedNumber.value);
        }
        return acc;
      }, []);

      let template_ids = this.collection.reduce((acc, element) => {
        const template_id = this.templatesByIdentifier[
          element.selectedNumber.value
        ].find((foo) => foo.name == element.selectedName)._id;
        if (!acc.includes(template_id)) {
          acc.push(template_id);
        }
        return acc;
      }, []);

      // console.log(JSON.parse(JSON.stringify(this.templatesByIdentifier)));
      // console.log(JSON.parse(JSON.stringify(this.collection)));
      const data = {
        name: this.name,
        identifiers,
        template_ids,
      };

      createTemplateCollection(data)
        .then(() => {
          this.$emit("input", "showModalAdd", false);
          this.$toast.open({
            position: "top",
            message: "Coleção cadastrada com sucesso!",
            type: "success",
          });
        })
        .catch((error) => {
          console.table(error);
          this.$toast.open({
            position: "top",
            message:
              "Ops, aconteceu um erro ao criar sua campanha! Tente mais tarde!",
            type: "error",
          });
          this.$toast.open({
            position: "top",
            message: "Verifique se o nome da sua campanha já foi criado!",
            type: "error",
          });
        })
        .finally(() => {
          this.$emit("renderTable");
        });
    },
  },
};
</script>

<style>
.whatsapp-container {
  padding: 1em;
  margin: 1em;
  height: 100%;
  width: 100%;
}
.whatsapp-body {
  display: flex;
  justify-content: center;
  align-content: center;
  padding: 1em;
  border-radius: 10px;
  color: #606060;
  background-color: #fff;
}
.whatsapp-body .whatsapp-message-body {
  white-space: pre-wrap;
}
.whatsapp-buttons-group {
  display: flex;
  flex-wrap: wrap;
  padding: 1.4em 0;
  gap: 0.8em;
}
.whatsapp-buttons-group .whatsapp-button {
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 40%;
  background-color: #fff;
  padding: 1em;
  border-radius: 10px;
  font-size: 14px;
  color: #46baea;
}
.custom-absolute-positioning {
  right: 0;
  left: 0;
  top: 0;
  bottom: 0;
  margin: auto;
}
.d-flex.groupbuttons {
  gap: 3em;
}
.size-badge {
  min-width: 80px;
}
.card.card-cascade .view.gradient-card-header {
  padding: 1rem 1rem;
  text-align: center;
}
.card.card-cascade h3,
.card.card-cascade h4 {
  margin-bottom: 0;
}
.text-size {
  font-size: 11pt;
}
.bg-color {
  background: #588cb8;
}
.input-wrapper {
  display: flex;
  flex-direction: column;
  width: 48%;
}
.row-label {
  display: flex !important;
  flex-direction: row;
  gap: 28%;
}
.v-select {
  margin-bottom: 0.5em;
}
</style>